module.exports = __webpack_public_path__ + "static/media/jishui.a27ddd2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/jishui.mp3
// module id = uOoR
// module chunks = 208